import React from "react";
import { BsFillTelephonePlusFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
const FooterPort = () => {
  return (
    <div className="row  overflow-hidden mainDropFilter " id="Footer">
      <div className="col-12 px-5 footerMAindiv d-md-flex">
        <h4 className="text-center mail d-flex align-items-center">
          <MdEmail className="mail_icon" />  Hamzafarooq925@gmail.com
        </h4>
        <h4 className="text-center mail d-flex align-items-center">
          <BsFillTelephonePlusFill className="mail_icon" /> +92-3466634029
        </h4>
      </div>
    </div>
  );
};

export default FooterPort;
